import types from './actionTypes';
import Requester from "../blueprint/svc";
import { interruptViewAction } from '../views/actions';
import { logError } from '../../utils/logger';
const fetch = new Requester();

export const handleSnackBar = (payload = {}, reset = false) => ({ type: types.TOGGLE_SNACKBAR, payload, reset });

export const handleSecSnackBar = (payload = {}, reset = false) => ({ type: types.TOGGLE_SEC_SNACKBAR, payload, reset });
export const handleMultiLineSnackBar = (payload = {}, reset = false) => ({ type: types.TOGGLE_MULTI_LINE_SNACKBAR, payload, reset });


export const setBuildLoader = (payload) => ({ type: types.SET_BUILD_LOADER, payload })
export const setDeployLoader = (payload) => ({ type: types.SET_DEPLOY_LOADER, payload })
export const setSelectedTransactionId = (payload) => dispatch => {
    // console.log({ payload })
    dispatch({ type: types.SET_CURRENT_TEMPLATE_TRANSACTION, transactionName: '' });
    dispatch({ type: types.SET_SELECTED_TRANSACTION_ID, payload })
}
export const setSelectedEvent = (payload) => ({ type: types.SET_SELECTED_EVENT, payload })

export const renderDataFlow = (payload) => ({ type: types.SET_DF_RENDER, payload })
export const renderTreeView = (payload) => {
    return { type: types.SET_TV_RENDER, payload }
}
export const reRenderInfoBuilder = () => ({ type: types.TRANSCTION_RENDER_COUNT })

export const updateBlueprintSlugDetails = (payload) => ({ type: types.UPDATE_BLUEPRINT_SLUG_DETAILS, payload })

export const updateFullGlobal = (payload) => ({
    type: types.UPDATE_FULL_GLOBAL,
    payload
})

// 
export const openLeftDrawer = () => ({ type: types.OPEN_LEFT_DRAWER, payload: {} })
export const closeLeftDrawer = () => ({ type: types.CLOSE_LEFT_DRAWER, payload: {} })
export const toggleLeftDrawer = () => ({ type: types.TOGGLE_LEFT_DRAWER, payload: {} })
export const toggleRightDrawer = () => ({ type: types.TOGGLE_RIGHT_DRAWER, payload: {} })
export const toggleBottomDrawer = () => ({ type: types.TOGGLE_BOTTOM_DRAWER, payload: {} })
export const openRightDrawer = () => ({type: types.OPEN_RIGHT_DRAWER, payload: {}})
export const setFocusElement2 = (payload) => ({ type: types.SET_FOCUS_ELEMENT, payload })
export const setActiveLabel = (payload) => ({type: types.SET_ACTIVE_LABEL, payload})
// Reducers for Image map
export const setImageMapData = (payload) => ({ type: types.SET_IMAGE_MAP, payload })
export const resetImageMapData = (payload) => ({ type: types.RESET_IMAGE_MAP, payload })


// Actions for triggering the tour
export const triggerTour = (payload) => ({ type: types.TRIGGER_TOUR, payload });
export const toggleTourNextStep = (payload) => ({type: types.TOGGLE_NEXT_STEP, payload })
export const addTourConfig = (payload) => ({ type: types.ADD_TOUR_CONFIG, payload })

export const handleLogs = (log, clear) => ({ type: types.HANDLE_LOGS, log, clear });

export const handleBottomTerminal = (isOpen, title) => ({ type: types.HANDLE_BOTTOM_TERMIAL, isOpen, title });
export const setTerminalOpen = (payload) => ({ type: types.SET_TERMINAL_OPEN, payload })

export const handleTopRightInfo = (payload) => ({ type: types.HANDLE_TOP_RIGHT_INFO, payload });
export const setTabOnFocus = (payload) => ({ type: types.SET_TAB_ON_FOCUS, payload });
export const setForcedFocus = (payload) => ({ type: types.SET_FORCED_FOCUS, payload });

export const setElementToCopy = (payload) => ({ type: types.SET_ELEMENT_TO_COPY, payload });

export const setTestcaseToCopy = (payload) => ({ type: types.SET_TESTCASE_TO_COPY, payload });

export const setDrawEvent = (status) => ({ type: types.DRAW_EVENT, status });
export const setDrawNestedTransaction = (status) => ({ type: types.DRAW_NESTED_TRANSACTION, status });
export const setDrawReuseTransaction = (status) => ({ type: types.DRAW_REUSE_TRANSACTION, status });
export const setTransactionToCreate = (payload) => ({ type: types.TRANSACTION_TO_CREATE, payload });
export const setTRansactionState = (status) => ({ type: types.SET_TRANSACTION_STATE, status });
export const setHighlightNode = (node) => ({ type: types.HIGHLIGHT_NODE, node });
export const setDrawnTransaction = (status) => ({ type: types.DRAWN_TRANSACTION, status });
// export const setDrawnReusedTransaction = (status) => ({ type: types.DRAWN_REUSEDTRANSACTION, status });
export const setSavingInProgress = (status) => ({ type: types.SAVING_IN_PROGRESS, status });
export const setNodeClicked = (payload) => ({ type: types.SET_CLICKED_NODE, payload });
export const setDisablePan = (status) => ({ type: types.SET_DISABLE_PAN, status })
export const setLatestFieldAdded = (payload) => ({ type: types.SET_LATEST_FIELD_ADDED, payload });

export const setLoadingFalse = () => (dispatch) => {
    dispatch({ type: types.SET_LOADING_FALSE })
}

export const setDrawTemplateTransaction = (status) => ({ type: types.DRAW_TEMPLATE_TRANSACTION, status });

export const setCurrentTemplateTransaction = transactionName => (dispatch) => {
    dispatch({ type: types.SET_SELECTED_TRANSACTION_ID, payload: '' })
    dispatch({ type: types.SET_CURRENT_TEMPLATE_TRANSACTION, transactionName });
}

export const setAppMode = mode => {
    return { type: types.SET_APP_MODE, mode }
}

export const setCurrentViewId = viewId => {
    return { type: types.CURRENT_VIEW_ID, viewId }
}

export const setAssetUpdated = () => {
    return { type: 'ASSET_UPDATED', value: Math.random(1111, 9999) }
}

export const setMenuAction = (payload) => ({ type: types.SET_MENU_ACTION, payload })

export const setViewElementToCopy = (payload) => ({ type: types.SET_VIEW_ELEMENT_TO_COPY, payload });
export const setApiResponseCode = (responseCode) => ({ type: types.SET_API_RESPONSE_CODE, responseCode });
export const setApiResponseMessage = (responseMessage) => ({ type: types.SET_API_RESPONSE_MESSAGE, responseMessage });

export const setReRender = (payload) => {
    return { type: types.SET_RE_RENDER, payload: '' }
}

export const setTriggerBlueprintValidation = (payload) => {
    return { type: types.SET_TRIGGER_VALIDATION, payload: '' }
}

export const detectPlatformSchemaChange = () => {
    return { type: types.DETECT_PLATFORM_SCHEMA_CHANGE }
}

export const setInnerScreenRender = (payload) => {
    return { type: types.SET_INNER_SCREEN_RENDER, payload: '' }
}

export const setIdeBuildVersion = (payload) => ({ type: types.SET_BUILD_VERSION, payload })


export const setDashboardRefresh = (payload) => ({ type: types.SET_DASHBOARD_REFRESH, payload })


/** API v2 - post */
export const invokePostService = (route, payload, query, apiPort = false, signal) => async (dispatch) => {
    try{
        const { response, status, url } = await fetch.postService(route, payload, query, dispatch, apiPort, signal);
        
        if (response?.aborted) {
            return { ...(response || {}), statusCode: status };
        }

        if (response.status === false && response.message && typeof response.message === 'object') {
            response.message = "Something went wrong!";
        }

        const aiAPIMatchRegex = /r1\/ai/;
        const isAiApi = aiAPIMatchRegex.test(url);
        
        if (response.code !== undefined) {
            if (response.code == 250) {
                alert(250)
            } else {
                if (status && status !== 200) {
                    if(route === "updateView"){
                        dispatch(interruptViewAction())
                    }else if (!response.suppressErrorToast && !isAiApi){
                        dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
                    }
                }
                dispatch(setApiResponseCode(response.code))
                if ([251, 252, 253, 254, 255].includes(response.code)) {
                    dispatch(setApiResponseMessage(response.message))
                }

            }
        } else {
            if (status && status !== 200) {
                if(route === "updateView"){
                    dispatch(interruptViewAction())
                }else if (!response.suppressErrorToast && !isAiApi){
                    dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
                }
            }
            // dispatch(setApiResponseCode(null))
        }
        return {...(response || {}), statusCode: status};
    }catch(error){
        if (error.name === 'AbortError') {
            return { status: false, aborted: true, message: 'Request aborted' };
        }
        console.log("error", error)
        logError({message: `Error occured in the invokePostService Function:\n ${error.message}`})
        dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
        return {status: false, message: error.message}
    }
}

export const invokePostV1Service = (route, payload, query, apiPort = false) => async (dispatch) => {
    try{
        const { response, status } = await fetch.postV1Service(route, payload, query, dispatch, apiPort);
        // console.log({ response, status }, 'response from API invokePostService')
        if (response.status === false && response.message && typeof response.message === 'object') {
            response.message = "Something went wrong!";
        }
        if (response.code !== undefined) {
            if (response.code == 250) {
                alert(250)
            } else {
                if (status && status !== 200) {
                    dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
                }
                dispatch(setApiResponseCode(response.code))
                if ([251, 252, 253, 254, 255].includes(response.code)) {
                    dispatch(setApiResponseMessage(response.message))
                }
    
            }
        } else {
            if (status && status !== 200) {
                dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
            }
            // dispatch(setApiResponseCode(null))
        }
        return response;
    }catch(error){
        logError({message: `Error occured in the invokePostV1Service Function: ${error.message}`})
        dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
    }
}

export const invokePostFileService = (route, payload, query) => async (dispatch) => {
    try{
        const { response, status } = await fetch.postFileService(route, payload, query, dispatch);
        // console.log({ response, status }, 'response from API invokePostService')
        if (response.code !== undefined) {
            if (response.code == 250) {
                alert(250)
            } else {
                if (status && status !== 200) {
                    dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
                }
                dispatch(setApiResponseCode(response.code))
                if ([251, 252, 253, 254, 255].includes(response.code)) {
                    dispatch(setApiResponseMessage(response.message))
                }

            }
        } else {
            if (status && status !== 200) {
                dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
            }
            // dispatch(setApiResponseCode(null))
        }
        return response;
    }catch(error){
        logError({message: `Error occured in the invokePostFileService Function: ${error.message}`})
        dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
    }
}


/** API v2 - get */
export const invokeGetService = (route, payload, apiPort = false) => async (dispatch) => {
    try{
        const { response, status } = await fetch.getService(route, payload, dispatch, apiPort);
    
        if (response.status === false && response.message && typeof response.message === 'object') {
            response.message = "Something went wrong!";
        }
        if (response.code !== undefined) {
            if (response.code == 250) {
                alert(250)
            } else {
                if (status && (status !== 200 && status !== 202)) {
                    dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
                }
                dispatch(setApiResponseCode(response.code))
                if ([251, 252, 253, 254, 255, 257].includes(response.code)) {
                    dispatch(setApiResponseMessage(response.message))
                }
            }
        } else {
            if (status && (status !== 200 && status !== 202)) {
                dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
            }

        }
        return response;
    }catch(error){
        logError({message: `Error occured in the invokeGetService Function: ${error.message}`})
        dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
    }
}

/** For v1 APIs */
export const invokeV1GetService = (route, payload, apiPort = false) => async (dispatch) => {
    try{
        const { response, status } = await fetch.getV1Service(route, payload, dispatch, apiPort);
    
        if (response.status === false && response.message && typeof response.message === 'object') {
            response.message = "Something went wrong!";
        }
        if (response.code !== undefined) {
            if (response.code == 250) {
                alert(250)
            } else {
                if (status && status !== 200) {
                    dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
                }
                dispatch(setApiResponseCode(response.code))
                if ([251, 252, 253, 254, 255, 257].includes(response.code)) {
                    dispatch(setApiResponseMessage(response.message))
                }
            }
        } else {
            if (status && status !== 200) {
                dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
            }

        }
        return response;
    }catch(error){
        logError({message: `Error occured in the invokeV1GetService Function:\n ${error.message}`})
        dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
    }
}



export const invokeFileDownloadService = (route, payload) => async (dispatch) => {
    try{
        const response = await fetch.downloadService(route, payload);
        // console.log({ response }, 'response from API invokeFileDownloadService')
        // if (response.status === false && response.message && typeof response.message === 'object') {
        //     response.message = "Something went wrong!";
        // }
        // if (response.code !== undefined) {
        //     if (response.code == 250) {
        //         alert(250)
        //     } else {
        //         if (status && status !== 200) {
        //             dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
        //         }
        //         dispatch(setApiResponseCode(response.code))
        //         if ([251, 252, 253, 254, 255, 257].includes(response.code)) {
        //             dispatch(setApiResponseMessage(response.message))
        //         }
        //     }
        // } else {
        //     if (status && status !== 200) {
        //         dispatch(handleSnackBar({ open: true, message: response.message ? response.message : response.error ? response.error : "Something went wrong", severity: "error" }));
        //     }
        //     // dispatch(setApiResponseCode(null));
        // }
        return response;
    }catch(error){
        logError({message: `Error occured in the invokeFileDownloadService Function:\n ${error.message}`})
        dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
    }
}

export const setHeaderName = (payload) => {
    return { type: types.SET_HEADER_NAME, payload: payload }
}


export const setFocusElement = (payload) => (dispatch) => {
    dispatch(setHeaderName(''));
    dispatch(setFocusElement2(payload));
}

export const setNestedTransactionEvents = (payload) => {
    return { type: types.SET_TRANSACTION_EVENTS, payload: payload }
}

export const setNestedTransactionClusterlets = (payload) => {
    return { type: types.SET_TRANSACTION_CLUSTERLETS, payload: payload }
}

export const setNestedTransactionChildren = (payload) => {
    return { type: types.SET_TRANSACTION_CHILDREN, payload: payload }
}

export const setNestedTransactionInvoked = (payload) => {
    return { type: types.SET_TRANSACTION_INVOKED, payload: payload }
}

export const setParentTransaction = (payload) => {
    return { type: types.SET_PARENT_TRANSACTION, payload: payload }
}

export const setDisabled = (payload) => {
    return { type: types.SET_DISABLED, payload: payload }
}

export const setCodeEditStatus = (payload) => {
    return { type: types.SET_CODE_EDIT_STATUS, payload }
}

export const setIsDocumentClicked = () => { // Used to trigger the handler/utility function save alert when closing handler/utility function through any method
    return { type: types.SET_IS_DOCUMENT_CLICKED, payload: '' }
}

export const setSimulationTransaction = (payload) => {
    return { type: types.SET_SIMULATION_TRANSACTION, payload: payload }
}


// For sending real-time updates and events from the server to a web page over a single HTTP connection
export const invokeServerSentEventService = (route, params, onMessageCallback, onErrorCallback, onCloseCallback, port2 = false) => async (dispatch) => {
    let eventSource;
    try {
        eventSource = fetch.serverSentEventService(route, params, port2);

        eventSource.onmessage = (event) => {
            // console.log('event.data------>', event.data.replace(/hbx_newline/g, "\r\n"))
            onMessageCallback(event.data.replace(/hbx_newline/g, "\r\n"));
        }

        eventSource.onerror = (event) => {
            // console.log("error---------", event)
            if (event.eventPhase === EventSource.CLOSED) {
                // console.log("-----SSE closed-----")
                eventSource.close();
                onCloseCallback(event);
            }
            if (event.data) onErrorCallback(event.data);
        };

    } catch (error) {
        logError({message: `Error occured in the invokeServerSentEventService Function:\n ${error.message}`})
        eventSource?.close();
    }
}

export const closeBottomTerminal = (payload) => {
    return { type: types.SET_BOTTOM_TERMINAL_CLOSED, payload: payload }
}


export const openTransactionSelectorForSimulation = (status) => {
    return { type: types.OPEN_TRANSACTION_SELECTOR, payload: status }
}

export const toggleSetPaperReadyForTransaction = (status) => {
    return { type: types.SET_PAPER_FOR_SIMULATION_TRANSACTION, payload: status }
}

export const setExpanded = (id) => {
    // console.log("ParentId-------->", id)
    return { type: types.SET_NODE_EXPANDED, payload: id }
}

export const setBuildStatus = (status) => {
    return { type: types.SET_BUILD_STATUS, payload: status }
}

export const initMigrationApproval = (details) => {
    return {type: types.INIT_MIGRATION_APPROVAL, payload: details}
}

export const saveDialogScrollLocation = (details) => {
    return {type: types.SAVE_DIALOG_SCROLL_LOCATION, payload: details}
}


export const startUploadProgress = (payload) => ({ type: types.START_UPLOAD_PROGRESS, payload })
export const updateUploadProgress = (payload) => ({ type: types.UPDATE_UPLOAD_PROGRESS, payload })
export const removeUploadProgress = (payload) => ({ type: types.REMOVE_UPLOAD_PROGRESS, payload })
export const generateLlmComponents = (payload) => ({ type: types.GENERATE_LLM_COMPONENTS, payload })
export const showAcceptRejectButtons = (payload) => ({ type: types.SHOW_ACCEPT_REJECT_BUTTONS, payload })
export const setLlmQuery = (payload) => ({ type: types.LLM_QUERY, payload })
export const setLlmModel = (payload) => ({ type: types.LLM_MODEL, payload })
export const collapsableSidebarStatus= (payload) => ({ type: types.COLLAPSABLE_SIDEBAR_STATUS, payload })

export const openAiPromptModal = (payload) => ({ type: types.AI_ASSISTANT_MODAL_OPEN, payload })
export const closeAiAssistantModal = (payload) => ({ type: types.AI_ASSISTANT_MODAL_CLOSE, payload })
export const updateAiAssistant = (payload) => ({ type: types.AI_ASSISTANT_UPDATE, payload })
export const setAiRequestEntity = (payload) => ({ type: types.SET_AI_REQUEST_ENTITY, payload })
export const generateWidgetTransactionWithAI = (payload) => ({ type: types.GENERATE_WIDGET_TRANSACTION, payload })
export const setAiAutoProceed = (payload) => ({ type: types.SET_AI_AUTO_PROCEED, payload })
export const setLogHelper = (payload) => ({type: types.SET_LOG_HELPER, payload})
export const toggleSimulationRun = (payload) => ({type: types.TOGGLE_SIMULATION_RUN, payload})
export const toggleValidator = (payload) => ({type: types.TOGGLE_VALIDATOR, payload})
export const toggleDeployment = (payload) => ({type: types.TOGGLE_DEPLOYMENT, payload})
export const updateLogRedirectionData = (payload) => ({type: types.UPDATE_LOG_REDIRECTION_DATA, payload})
